// Se encarga de ordenar un listado de preguntas en grupos, de manera que se pueda mostrar en pantalla un grupo de preguntas por fila
export const orderQuestionsByGroups = (questions, questionGroups) => {
  return questions.reduce((result, element, index) => {
    const matchingQuestionGroup = findInSingleRowQuestions(index, questionGroups);
    if (matchingQuestionGroup && matchingQuestionGroup.includes(index)) {
      // Si el elemento anterior no es un arreglo se debe crear para empezar a agregar los elementos agrupados dentro
      if (matchingQuestionGroup[0] === index) {
        result.push([]);
      }
      result[result.length - 1].push(element);
      return result;
    }
    result.push(element);
    return result;
  }, []);
};

export const findInSingleRowQuestions = (index, questionGroups) =>
  questionGroups.find((questionGroup) =>
    questionGroup.some((questionIndex) => questionIndex === index)
  );

export const dimensionHasAnswers = (answers, dimensionIndex) => {
  if (!answers || !answers[dimensionIndex] || Object.keys(answers[dimensionIndex]).length === 0) {
    return false;
  }

  return true;
};
